import http from "../api";
import fileHttp from "../api/fileApi";

export const getAgencies = async (data) => {
  const { page, limit, filters } = data;

  let url = `/user/get-all-users?page=${page}&limit=${limit}`;

  if (filters && Object.keys(filters).length > 0) {
    Object.keys(filters).forEach((fl) => {
      url = url + `${filters[fl] ? `&filters[${fl}]=${filters[fl]}` : ""}`;
    });
  }

  return await http.get(url);
};

export const deleteAgencies = async (id) => {
  return await http.delete(`/user/${id}`);
};

export const addAgency = async (data) => {
  return await http.post("/user/add-agency", data);
};

export const updateAgency = async (id, data) => {
  return await http.put(`/user/update-user/${id}`, data);
};

export const getAgenciesWOL = async () => {
  return await http.get("/user/get-all-users-wol");
};

export const exportAgencies = async () => {
  return await http.get("/user/export-user-data");
};

export const getBusesAndChargersCount = async (id) => {
  return await http.get(`/user/buses-chargers-count/${id}`);
};

export const uploadAgenciesFile = async (data) => {
  return await fileHttp.post("/user/upload-file", data);
};

export const updateEmail = async (data) => {
  return await http.patch(`/user/update-email`, data);
};
